<template>
	<div class="lbt_box">
		
		<img class="lbt_img" src="../static/home/bg_1.png" alt="" v-show="num==0||num==1">
		<img class="lbt_img" src="../static/home/bg_2.png" alt="" v-show="num==1||num==2">
		<img class="lbt_img" src="../static/home/bg_3.png" alt="" v-show="num==2||num==3">
		<img class="lbt_img" src="../static/home/bg_4.png" alt="" v-show="num==3">
		
		<div class="gradual_1" v-if="num==0">
			<img class="ctgz_1" src="../static/home/cn_1.png" alt="">
			<img class="ctgz_2" src="../static/home/cn_2.png" alt="">
			<div class="text_1box">
				<div class="text_1">
					奇妙体验之旅<br>蘑菇乐园<br>尽情地玩耍和探索 <br>同时也可以学习和成长
				</div>
			</div>
		</div>
		<div class="gradual_1" v-if="num==1">
			<img class="ctgz_1" src="../static/home/cn_1.png" alt="">
			<img class="ctgz_2" src="../static/home/cn_22.png" alt="">
			<div class="text_1box">
				<div class="text_1">
					和小伙伴一起<br>体验欢乐的<br>轻松创意游戏 <br>感受互动带来的 <br>欢笑与感动
				</div>
			</div>
		</div>
		<div class="gradual_1" v-if="num==2">
			<img class="ctgz_1" src="../static/home/cn_1.png" alt="">
			<img class="ctgz_2" src="../static/home/cn_23.png" alt="">
			<div class="text_1box">
				<div class="text_1">
					书院深处<br>有一片幽静谧的小天地<br>在那里<br>你可以聆听鸟儿的鸣啼声<br>感受花草的清香
				</div>
			</div>
		</div>
		<div class="gradual_1" v-if="num==3">
			<img class="ctgz_1" src="../static/home/cn_1.png" alt="">
			<img class="ctgz_2" src="../static/home/cn_22.png" alt="">
			<div class="text_1box">
				<div class="text_1">
					一段难忘旅程<br>带给你的是最真实<br>最纯粹的美好体验 <br>让我一起噗通掉进 <br>童话的世界里吧！
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tirm : null,	//定时器
				num : 0,		//第几个
				
				
				imgs:[],		//轮播图
			}
		},
		created() {
			this.Rotation();
			
			
		},
		methods:{
			Rotation(){
				var that = this
				this.tirm = setInterval(function(){
					if(that.num<3){
						that.num++ 
					}else{
						that.num=0
					}
				},9000)
			},
			
			
		},
		
		beforeDestroy(){	//退出页面时间
			clearInterval(this.tirm)
			this.tirm = null;
			
			
		}
		
	}
</script>

<style scoped lang="less">
	.lbt_box{
		width: 1920px;
		height: 100%;
		background-color: #30446a;
		
		position: relative;
		
	}
	
	// 
	.lbt_img{
		position: absolute;
		top: 0;
		left: 0;
		transition: 1s all;
		width: 1920px;
		height: 100%;
		object-fit: cover;
		background-repeat: no-repeat;
		animation: bgimg 12s;
		animation-fill-mode: forwards;
	}
		@keyframes bgimg{
			0%{
				transform: scale(1.2);
				opacity: 1;
			}
			25%{
				transform: scale(1);
				opacity: 1;
				z-index: 2;
			}
			75%{
				transform: scale(1);
				opacity: 1;
				z-index: 3;
			}
			100%{
				transform: scale(1.2);
				opacity: 0;
				z-index: 3;
			}
		}
	
	// 
	.gradual_1{
		position: absolute;
		z-index: 10;
		left: 110px;
		top: 30%;
		transform:translateY(-50px);
	}
	.ctgz_1{
		width: 354px;
		height: 80px;
		position: absolute;
		top: 0;
		left: 0;
		opacity: 0;
		animation: ctgzdh 2s;
		animation-fill-mode: forwards;
	}
		@keyframes ctgzdh{
			0%{
				transform: scale(1.2);
				opacity: 0;
			}
			100%{
				transform: scale(1);
				opacity: 1;
			}
		}
	
	.ctgz_2{
		width: 435px;
		height: 104px;
		position: absolute;
		top: 92px;
		left: -44px;
		opacity: 0;
		animation: wenzimg 2s;
		animation-fill-mode: forwards;
		animation-delay:2s;
	}
		@keyframes wenzimg{
			0%{
				transform:translateX(-50%);
				opacity: 0;
			}
			100%{
				transform:translateX(0);
				opacity: 1;
			}
		}
	.text_1box{
		position: absolute;
		top: 200px;
		left: 10px;
	}
	.text_1{
		font-size: 18px;
		color: #fff;
		line-height: 30px;
		letter-spacing: 3px;
		
		writing-mode: vertical-lr;
		opacity: 0;
		animation: textdh 2s;
		animation-fill-mode: forwards;
		animation-delay:4s;
	}
		@keyframes textdh{
			0%{
				transform:translateX(-50%);
				opacity: 0;
			}
			100%{
				opacity: 1;
			}
		}
	
	
	
</style>